import { AppService } from '../../app.service';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { UtilityFunctions } from '../../shared/utility-functions';
import * as _ from 'lodash';

export class FacilityValidation {
  public validate;

  constructor(private appService: AppService, private utilityFunctions: UtilityFunctions) {
    this.validate = {
      validName: '',
      validNoOfUnits: '',
      validSlotDuration: '',
      validCategory: '',
      validOpenTime_hour: '',
      validOpenTime_minute: '',
      validCloseTime_hour: '',
      validCloseTime_minute: '',
      validBreakStart: '',
      validBreakStop: '',
      validUnitName: '',
      validIcon: '',
      validAmount: '',
      validHoldBooking: '',
      validMaxNumberOfPeopleWeekday: '',
      validMaxNumberOfPeopleWeekend: '',
      validMaxWeekdayBooking: '',
      validMaxWeekendBooking: '',
      validMaxBookingHoursWeekday: '',
      validmaxBookingHoursWeekend: '',
      validWaitlistCount: '',
      validPeekTime: '',
      validReminder: '',
      validNotificationAcceptanceHour: '',
      validPeekSlotDuraion: '',
      validUnitNames: '',
      flag: true,
      validClosedTime: '',
      validmaxNumberOfPeoplePerSlot: '',
      bookingUnit_minute: '',
      bookingUnit_hour: '',
      GSTValue: ''
    };
  }
  validateNamePara(that, validPara, obj, facilityPara) {
    if (obj) {
      if (facilityPara == 'name') {
        if (!this.utilityFunctions.validateFacilityName(that[obj][facilityPara]) || that[obj][facilityPara] == '') {
          this.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        } else {
          this.validate[validPara] = '';
        }
      } else {
        if (!this.utilityFunctions.validateFacilityName(that[obj][facilityPara]) || that[obj][facilityPara] == '') {
          this.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        } else {
          this.validate[validPara] = '';
        }
      }
    }
    else {
      if (!this.utilityFunctions.validatenameString(that[facilityPara]) || that[facilityPara] == '') {
        this.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      } else {
        this.validate[validPara] = '';
      }
    }
  }

  validateParaForNUll(that, validPara, obj, facilityPara) {
    let thatFacilityValidation = this;
    if (obj) {
      setTimeout(function () {
        if (that[obj][facilityPara] === '') {
          thatFacilityValidation.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        } else {
          thatFacilityValidation.validate[validPara] = '';
        }
      }, 1000);
    } else {
      setTimeout(function () {
        if (!that[facilityPara]) {
          thatFacilityValidation.validate[validPara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        } else {
          thatFacilityValidation.validate[validPara] = '';
        }
      }, 1000);
    }
  }

  validateTimeArray(that, flagToCheck, timeArray, validatePara) {
    let thatFacilityValidation = this;
    setTimeout(function () {
      if (!that.facility[flagToCheck]) {
        that[timeArray] = [];
      }
      if (that[timeArray].length <= 0 && that.facility[flagToCheck]) {
        thatFacilityValidation.validate[validatePara] = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      } else {
        thatFacilityValidation.validate[validatePara] = '';
      }
    }, 0);
  }
  /**
   * set activity time
   *
   * @param {any} that
   * @param {any} iconObj
   *
   * @memberof FacilityValidation
   */
  setLocalValuestoFacility(that, iconObj?) {
    that.facility.timings.openTime = that.openTime_hour && that.openTime_minute ? that.openTime_hour + ':' + that.openTime_minute + ':00:00' : '';
    that.facility.timings.closeTime = that.closeTime_hour && that.closeTime_minute ? that.closeTime_hour + ':' + that.closeTime_minute + ':00:00' : '';
    // when super admin create activity for specific condo
    if (that.vendor) {
  if (
    that.vendor.subVendors &&
    Array.isArray(that.vendor.subVendors) &&
    that.vendor.subVendors.length > 0
  ) {
    let subvendor = that.vendor.subVendors[0];
    that.facility.vendorId = subvendor._id;
  }
}

    that.facility.isAttendeeCountRequired = that.isAttendeeCountRequired;
    that.facility.isMaxBookingsPerSlot = that.isMaxBookingsPerSlot;
    that.facility.isWaitlistEnabled = that.isWaitlistEnabled;
    that.facility.isChargable = that.isChargable;
    that.facility.isPeakTimeEnabled = that.isPeakTimeEnabled;
    that.facility.isBreakTimeEnabled = that.isBreakTimeEnabled;
    that.facility.isHoldBooking = that.facility.isChargable;
    that.facility.isMaxBookingPerMembership = that.isMaxBookingPerMembership;
    that.facility.isAllowForceBooking = that.isAllowForceBooking;
    that.facility.isMaxBookingPerPerson = that.isMaxBookingPerPerson;
    if (iconObj && iconObj.name) {
      that.viewIcon.name = iconObj.name;
      that.viewIcon.iconClass = iconObj.iconClass;
      that.facility.icon = iconObj.name;
    }
    that.facility.isCourtSelection = that.isCourtSelection;
    that.facility.isOpenBookingOnFriday = that.isOpenBookingOnFriday;
    that.facility.isOpenNextMonthBooking = that.isOpenNextMonthBooking;
    that.facility.isSlotsLocked = that.isSlotsLocked;
    that.facility.isCreatedForGroup = that.isCreatedForGroup;
    that.facility.isWeeklyRepeatBooking = that.isWeeklyRepeatBooking;
    that.facility.isGSTApplicable = that.isGSTApplicable;
  }

  changedRuleForAminity(that) {
    if (_.indexOf(CONSTANT_VALUES.AMENITIES, that.facility.category) >= 0) {
      that.facility.maxBookingHoursWeekday = '';
      that.facility.maxBookingHoursWeekend = '';
      that.facility.isMaxBookingPerPerson = false;
      that.facility.maxWeekdayBooking = '';
      that.facility.maxWeekendBooking = '';
      if (that.facility.isMaxBookingPerMembership) {
        that.facility.maxBookingHoursMonth = '4';
      } else {
        that.facility.maxBookingHoursMonth = ''
      }
    }
  }

  setProperValuesToFacilityObj(that) {
    let timeObject = {};
    let unit;
    that.facility.unitNames = [];
    that.unitNames = that.unitNames.trim();
    that.facility.name = that.facility.name.trim();
    that.popUp = false;
    for (let i = 1; i <= parseInt(that.facility.noOfUnits); i++) {
      unit = that.unitNames + '-' + i;
      that.facility.unitNames.push(unit);
    }
    that.facility.breakTimings = [];
    that.facility.peekTimings = [];
    for (let item of that.closeTimeArray) {
      timeObject['start'] = item.start + ':00:00';
      timeObject['end'] = item.end + ':00:00';
      that.facility.breakTimings.push(timeObject);
      timeObject = {};
    }
    for (let item of that.peekTimingsArray) {
      timeObject['start'] = item.start + ':00:00';
      timeObject['end'] = item.end + ':00:00';
      that.facility.peekTimings.push(timeObject);
      timeObject = {};
    }
    if (that.facility.isChargable === false) {
      that.facility.amount.value = '';
      that.facility.holdBookingDays = '';
    }
    if (that.facility.isMaxBookingPerMembership === false) {
      that.facility.maxBookingHoursWeekday = '';
      that.facility.maxBookingHoursWeekend = '';
      that.facility.maxBookingHoursMonth = '';
    }
    if (that.facility.isMaxBookingPerPerson === false) {
      that.facility.maxWeekdayBooking = '';
      that.facility.maxWeekendBooking = '';
    }
    if (that.facility.isWaitlistEnabled === false) {
      that.facility.waitlistCount = '';
    }
    if (that.facility.isPeakTimeEnabled === false) {
      that.facility.peekTimings = [];
    }
    if (that.facility.isBreakTimeEnabled === false) {
      that.facility.breakTimings = [];
    }
    // that.setUTCTime();
    if (_.indexOf(CONSTANT_VALUES.AMENITIES, that.facility.category) >= 0) {
      that.facility.slotDuration = '0';
    }
    if (!that.facility.isPeakTimeEnabled) {
      that.facility.peakUnitsCount = '0';
    }
    this.changedRuleForAminity(that);
  }

  validateFacilityTimings(that, validateField, iconObj) {
    this.setLocalValuestoFacility(that, iconObj);
    switch (validateField) {
      case 'openTime_hour':
        this.validateParaForNUll(that, 'validOpenTime_hour', '', 'openTime_hour');
        break;
      case 'openTime_minute':
        this.validateParaForNUll(that, 'validOpenTime_minute', '', 'openTime_minute');
        break;
      case 'closeTime_hour':
        this.validateParaForNUll(that, 'validCloseTime_hour', '', 'closeTime_hour');
        break;
      case 'closeTime_minute':
        this.validateParaForNUll(that, 'validCloseTime_minute', '', 'closeTime_minute');
        break;
      case 'facility.peakTime':
        this.validateTimeArray(that, 'isPeakTimeEnabled', 'peekTimingsArray', 'validPeekTime');
        break;
      case 'closedTime':
        this.validateTimeArray(that, 'isBreakTimeEnabled', 'closeTimeArray', 'validClosedTime');
        break;
    }
  }

  validateFacilityChargesHoldBookings(that, validateField, iconObj, butt31?, butt32?) {
    this.setLocalValuestoFacility(that, iconObj);
    switch (validateField) {
      case 'facility.holdBookingDays':
        if (!that.facility.isChargable) {
          that.facility.holdBookingDays = '';
        }
        if (that.facility.isChargable) {
          this.validateParaForNUll(that, 'validHoldBooking', 'facility', 'holdBookingDays');
        } else {
          this.validate.validHoldBooking = '';
        }
        break;
      case 'facility.amount.value':
        if (!that.facility.isChargable || (that.facility.amount.value === null || (that.facility.isChargable && that.facility.amount.value < 0))) {
          that.facility.amount.value = '';
        }
        if (that.facility.isChargable && that.facility.amount.value === '') {
          this.validate.validAmount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        } else {
          this.validate.validAmount = '';
        }

        if (that.facility.amount.value == '0') {
          this.validate.GSTValue = '';
          that.facility.GSTValue = '';
          that.toggle(this, 17, false);
          that.facility.isGSTApplicable = false;
          that.changeClassForToggle(butt31, butt32);
        }
        break;
    }
  }

  validateFacilityReminderNotification(that, validateField, iconObj) {
    this.setLocalValuestoFacility(that, iconObj);
    let thatFacilityValidation = this;
    switch (validateField) {
      case 'facility.reminder.value':
        setTimeout(function () {
          if (that.facility.reminder.value === '') {
            thatFacilityValidation.validate.validReminder = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            thatFacilityValidation.validate.validReminder = '';
          }
        }, 0);
        break;
      case 'facility.notificationAcceptanceHour':
        setTimeout(function () {
          if (that.facility.notificationAcceptanceHour === '') {
            thatFacilityValidation.validate.validNotificationAcceptanceHour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            thatFacilityValidation.validate.validNotificationAcceptanceHour = '';
          }
        }, 0);
        break;
    }
  }
  validateFacilityMaxAttendees(that, validateField, iconObj) {
    this.setLocalValuestoFacility(that, iconObj);
    switch (validateField) {
      case 'facility.maxNumberOfPeopleWeekday':
        if (that.facility.maxNumberOfPeopleWeekday <= '0' && that.facility.isAttendeeCountRequired) {
          that.facility.maxNumberOfPeopleWeekday = '';
        } else {
          if (that.facility.isAttendeeCountRequired) {
            this.validateParaForNUll(that, 'validMaxNumberOfPeopleWeekday', 'facility', 'maxNumberOfPeopleWeekday');
          } else {
            this.validate.validMaxNumberOfPeopleWeekday = '';
            that.facility.maxNumberOfPeopleWeekday = '';
          }
        }
        break;
      case 'facility.maxNumberOfPeopleWeekend':
        if (that.facility.maxNumberOfPeopleWeekend <= '0' && that.facility.isAttendeeCountRequired) {
          that.facility.maxNumberOfPeopleWeekend = '';
        } else {
          if (that.facility.isAttendeeCountRequired) {
            this.validateParaForNUll(that, 'validMaxNumberOfPeopleWeekend', 'facility', 'maxNumberOfPeopleWeekend');
          } else {
            this.validate.validMaxNumberOfPeopleWeekend = '';
            that.facility.maxNumberOfPeopleWeekend = '';
          }
        }
        break;
    }
  }

  validateFacilityBookings(that, validateField, iconObj) {
    this.setLocalValuestoFacility(that, iconObj);
    switch (validateField) {
      case 'maxBookingHoursWeekday':
        if (that.facility.isMaxBookingPerMembership) {
          this.validateParaForNUll(that, 'validMaxBookingHoursWeekday', 'facility', 'maxBookingHoursWeekday');
        } else {
          this.validate.validMaxBookingHoursWeekday = '';
          that.facility.maxBookingHoursWeekday = '';
        }
        break;
      case 'facility.maxBookingHoursWeekend':
        if (that.facility.isMaxBookingPerMembership) {
          this.validateParaForNUll(that, 'validmaxBookingHoursWeekend', 'facility', 'maxBookingHoursWeekend');
        }
        else {
          this.validate.validmaxBookingHoursWeekend = '';
          that.facility.maxBookingHoursWeekend = '';
        }
        break;
      case 'facility.maxWeekdayBooking':
        if (that.facility.isMaxBookingPerPerson) {
          this.validateParaForNUll(that, 'validMaxWeekdayBooking', 'facility', 'maxWeekdayBooking');
        } else {
          this.validate.validMaxWeekdayBooking = '';
          that.facility.maxWeekdayBooking = '';
        }
        break;
      case 'facility.maxWeekendBooking':
        if (that.facility.isMaxBookingPerPerson) {
          this.validateParaForNUll(that, 'validMaxWeekendBooking', 'facility', 'maxWeekendBooking');
        } else {
          this.validate.validMaxWeekendBooking = '';
          that.facility.maxWeekendBooking = '';
        }
        break;
    }
  }
  validateFacilityObj(that) {
    let flag;
    this.setLocalValuestoFacility(that, '');
    this.changedRuleForAminity(that);
    flag = that.facilityService.validateFacilityObject(that.facility, this.validate, that.unitNames, that.closeTimeArray, that.peekTimingsArray, that.functionHallFlag, that.bookingUnit_hour, that.bookingUnit_minute);
    return flag
  }

  /**
  * validate facility
  *
  * @param  validate field or facility object
  *
  * @response SUCCESS or FAILED
  */

  /**
  * setTimeout function is apply On drop down menu fields for validation
  *
  * @param  validate field or facility object
  *
  * @response SUCCESS or FAILED
  */


  validateFacility(that, validateField, iconObj) {
    this.setLocalValuestoFacility(that, iconObj);
    let thatFacilityValidation = this;
    switch (validateField) {
      case 'facility.category':
        // this.validateNamePara(that, 'validCategory', 'facility', 'category');
        if (that.facility.category) {
          this.validate.category = '';
        } else {
          this.validate.category = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        }
        break;
      case 'facility.name':
        this.validateNamePara(that, 'validName', 'facility', 'name');
        break;
      case 'unitNames':
        this.validateNamePara(that, 'validUnitNames', '', 'unitNames');
        break;
      case 'facility.noOfUnits':
        this.validateParaForNUll(that, 'validNoOfUnits', 'facility', 'noOfUnits');
        break;
      case 'icon':
        setTimeout(function () {
          if (iconObj.name === '') {
            thatFacilityValidation.validate.validIcon = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          } else {
            thatFacilityValidation.validate.validIcon = '';
          }
        }, 0);
        break;
      case 'facility.slotDuration':
        if (that.functionHallFlag) {
          this.validate.validSlotDuration = '';
        } else {
          this.validateParaForNUll(that, 'validSlotDuration', 'facility', 'slotDuration');
        }
        break;
      case 'facility.peakUnitsCount':
        if (that.functionHallFlag) {
          this.validate.validPeekSlotDuraion = '';
          return;
        } else if (that.facility.isPeakTimeEnabled) {
          this.validateParaForNUll(that, 'validPeekSlotDuraion', 'facility', 'peakUnitsCount');
        }
        else {
          this.validate.validPeekSlotDuraion = '';
        }
        break;
      case 'facility.waitlistCount':
        if (that.facility.waitlistCount <= '0' && that.facility.isWaitlistEnabled) {
          that.facility.waitlistCount = '';
        } else if (that.facility.isWaitlistEnabled) {
          this.validateParaForNUll(that, 'validWaitlistCount', 'facility', 'waitlistCount');
        } else {
          this.validate.validWaitlistCount = '';
        }
        break;
      case 'facility.maxBookingsPerSlot':
        if (!that.facility.maxBookingsPerSlot && that.facility.isMaxBookingsPerSlot) {
          this.validate.validmaxNumberOfPeoplePerSlot = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        } else if (that.facility.isMaxBookingsPerSlot) {
          this.validateParaForNUll(that, 'validmaxNumberOfPeoplePerSlot', 'facility', 'maxBookingsPerSlot');
        } else {
          this.validate.validmaxNumberOfPeoplePerSlot = '';
          that.facility.maxBookingsPerSlot = ''
        }
        break;
      case 'bookingUnit_hour':
        if (that.bookingUnit_hour || that.bookingUnit_hour == '00') {
          this.validate.bookingUnit_hour = '';
        } else {
          this.validate.bookingUnit_hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        }
        break;
      case 'bookingUnit_minute':
        if (that.bookingUnit_minute || that.bookingUnit_minute == '00') {
          this.validate.bookingUnit_minute = '';
        } else {
          this.validate.bookingUnit_minute = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        }
        break;
    }
  }

  validateMaxNumberOfPeoplePerSlot(that, validateField, iconObj) {
    if (that.facility.isMaxBookingsPerSlot) {
      this.setLocalValuestoFacility(that, iconObj);
    } else {
      that.facility.maxBookingsPerSlot = '';
      this.validate.validmaxNumberOfPeoplePerSlot = '';
    }
  }

  maxBookingPerSlot(that) {
    if (parseInt(that.facility.maxBookingsPerSlot) > 50) {
      return true;
    } else {
      return false;
    }
  }

  validateGST(that, validateField, iconObj) {
    this.setLocalValuestoFacility(that, iconObj);
    switch (validateField) {
      case 'facility.GSTValue':
        if (that.facility.isChargable) {
          if (that.facility.amount.value == '0') {
            this.validate.GSTValue = '';
            that.facility.GSTValue = ''
          } else if (that.facility.isGSTApplicable) {
            this.validate.GSTValue = that.facility.GSTValue ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            that.facility.GSTValue = (that.facility.GSTValue === null || (that.facility.GSTValue < 0)) ? '' : that.facility.GSTValue;
          } else {
            this.validate.GSTValue = '';
            that.facility.GSTValue = ''
          }
        } else {
          this.validate.GSTValue = '';
          that.facility.GSTValue = ''
        }
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/facility/facility-rule/facility-validation.ts